import { render, staticRenderFns } from "./EmailUserAssignmentModal.vue?vue&type=template&id=096636f0"
import script from "./EmailUserAssignmentModal.vue?vue&type=script&lang=js"
export * from "./EmailUserAssignmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports